// Librairies
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

// The theme colors of the former Material spinner, else any CSS color.
const COLORS: Record<string, string> = {
  primary: 'var(--primary-color)',
  accent: 'var(--secondary-color, var(--primary-color))',
  warn: 'var(--primary-color)',
};

// Loading: a light ring (a gradient arc turning on a discreet track), and its text beside it.
@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  imports: [
    CommonModule,
    TranslateModule
  ],
  standalone: true,
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.fill]': 'fill' }
})

export class SpinnerComponent {
  @Input() diameter: number = 16;
  @Input() fontSize: number = 16;
  @Input() color: string = 'warn';
  @Input() text: string = 'status.loading';
  @Input() iconOnly: boolean = false;
  @Input() textWidth: string = '';
  // A page loading: the spinner in the middle of the room it is given.
  @Input() fill: boolean = false;

  get ringColor(): string {
    return COLORS[this.color] ?? this.color;
  }

  // The ring thickness follows its size: 2px at 16px, 3px at 24px and more.
  get stroke(): number {
    return Math.max(2, Math.round(this.diameter / 8));
  }
}
